module.exports = __webpack_public_path__ + "static/img/ic_investigator_miror.9b5bc73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/ic_investigator_miror.png
// module id = JAr7
// module chunks = 0